import React from "react";

import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { FiBookmark } from "react-icons/fi";

import BookmarkService from "../../../../services/bookmark.service";
import { getTotalTime } from "../../../../util/getTotalTime";
import { NotificationToast } from "../../../Generic/Toast/NotificationToast";
import useVideoContext from "../../hooks/useVideoContext/useVideoContext";
import { ActionIconButton } from "../ActionIconButton";

export default function BookmarkButton(props: {
  disabled?: boolean;
  hours: number;
  minutes: number;
  seconds: number;
}) {
  const { hours, minutes, seconds } = props;
  const { task, taskIsValid, room, participantsAllowed } = useVideoContext();

  const { t: translate } = useTranslation();

  const { mutate: createBookmark } = useMutation(
    ["video.call.video.survey.room.bookmark"],
    (bookmark: any) => BookmarkService.create(bookmark),
    {
      onSuccess: () => {
        NotificationToast.success(translate("bookmarkSavedSuccessfully"));
      },
      onError: () => {
        NotificationToast.error(translate("couldNotSaveBookmark"));
      },
    }
  );

  const onCreateBookmark = () => {
    if (taskIsValid()) {
      createBookmark({
        videoTime: getTotalTime(hours, minutes, seconds),
        markDate: new Date(),
        taskId: task?.id,
      });
    }
  };

  return (
    <ActionIconButton
      dataCy="bookmarkAction"
      onClick={onCreateBookmark}
      disabled={!room || participantsAllowed?.length === 0}
      tooltipTitle={translate("saveABookmark")}
    >
      <FiBookmark />
    </ActionIconButton>
  );
}
